export default {
  data() {
    return {
      topData: [{
        num: "600+",
        label: "合作商家"
      }, {
        num: "30w+",
        label: "日活"
      }, {
        num: "50w次/天",
        label: "广告曝光"
      }, {
        num: "2000w/年",
        label: "执行广告预算"
      }]
    };
  }
};